// app/javascript/settings_modals.js
// Centralized event delegation and modal orchestrator for Doccu Settings Shell & Governance Tabs (WO-007)
// Complies strictly with Content Security Policy (zero inline scripts, zero inline handlers)

function setupSettingsEventDelegation () {
  // Click handler delegation
  document.addEventListener('click', (event) => {
    // 1. Generic Modal Opener: data-action="open-modal"
    const openModalBtn = event.target.closest('[data-action="open-modal"]')
    if (openModalBtn) {
      event.preventDefault()
      const targetId = openModalBtn.getAttribute('data-target')
      const targetEl = targetId ? document.getElementById(targetId) : null
      if (targetEl) {
        if (typeof targetEl.showModal === 'function') {
          targetEl.showModal()
        } else {
          targetEl.classList.remove('hidden')
        }
      }
      return
    }

    // 2. Generic Modal Closer: data-action="close-modal"
    const closeModalBtn = event.target.closest('[data-action="close-modal"]')
    if (closeModalBtn) {
      event.preventDefault()
      const targetId = closeModalBtn.getAttribute('data-target')
      const targetEl = targetId
        ? document.getElementById(targetId)
        : closeModalBtn.closest('dialog, [role="dialog"], [id^="top-up-modal-"], [id$="-modal"]')

      if (targetEl) {
        if (typeof targetEl.close === 'function') {
          targetEl.close()
        } else {
          targetEl.classList.add('hidden')
        }
      }
      return
    }

    // 3. User Artifact Drawer Toggle: data-action="toggle-drawer"
    const toggleDrawerBtn = event.target.closest('[data-action="toggle-drawer"]')
    if (toggleDrawerBtn) {
      event.preventDefault()
      const targetId = toggleDrawerBtn.getAttribute('data-target')
      const drawer = targetId ? document.getElementById(targetId) : null
      if (drawer) {
        const isHidden = drawer.classList.contains('hidden')
        drawer.classList.toggle('hidden')
        const icon = toggleDrawerBtn.querySelector('svg')
        if (icon) {
          if (isHidden) {
            icon.classList.add('rotate-180')
          } else {
            icon.classList.remove('rotate-180')
          }
        }
      }
      return
    }

    // 4. Remove User Modal Trigger: data-action="open-remove-user"
    const removeUserBtn = event.target.closest('[data-action="open-remove-user"]')
    if (removeUserBtn) {
      event.preventDefault()
      const userId = removeUserBtn.getAttribute('data-user-id')
      const userName = removeUserBtn.getAttribute('data-user-name')
      const userEmail = removeUserBtn.getAttribute('data-user-email')

      const modal = document.getElementById('remove-user-modal')
      const form = document.getElementById('remove-user-form')
      const nameSpan = document.getElementById('remove-modal-user-name')
      const emailSpan = document.getElementById('remove-modal-target-email')
      const input = document.getElementById('remove-modal-email-input')
      const submitBtn = document.getElementById('remove-modal-submit-btn')

      if (nameSpan) nameSpan.textContent = userName || 'Member'
      if (emailSpan) {
        emailSpan.textContent = userEmail || ''
        emailSpan.setAttribute('data-target-email', (userEmail || '').trim().toLowerCase())
      }
      if (form && userId) {
        form.action = `/settings/users/${userId}/remove`
      }
      if (input) input.value = ''
      if (submitBtn) submitBtn.disabled = true

      if (modal && typeof modal.showModal === 'function') {
        modal.showModal()
      }
      return
    }

    // 5. Close Remove User Modal: data-action="close-remove-user"
    const closeRemoveBtn = event.target.closest('[data-action="close-remove-user"]')
    if (closeRemoveBtn) {
      event.preventDefault()
      const modal = document.getElementById('remove-user-modal')
      const input = document.getElementById('remove-modal-email-input')
      const submitBtn = document.getElementById('remove-modal-submit-btn')
      if (input) input.value = ''
      if (submitBtn) submitBtn.disabled = true
      if (modal && typeof modal.close === 'function') {
        modal.close()
      }
      return
    }

    // 6. Support Modal Closes & Dialogs
    const closeDialogBtn = event.target.closest('[data-action="close-dialog"]')
    if (closeDialogBtn) {
      event.preventDefault()
      const targetId = closeDialogBtn.getAttribute('data-target')
      const dialog = targetId ? document.getElementById(targetId) : closeDialogBtn.closest('dialog')
      if (dialog && typeof dialog.close === 'function') {
        dialog.close()
      }
      return
    }

    // 7. Banner & Toast Dismissal: data-action="dismiss-banner", data-action="dismiss-toast"
    const dismissBtn = event.target.closest('[data-action="dismiss-banner"], [data-action="dismiss-toast"]')
    if (dismissBtn) {
      event.preventDefault()
      const targetId = dismissBtn.getAttribute('data-target')
      const targetEl = targetId ? document.getElementById(targetId) : dismissBtn.closest('#top-up-success-banner, #payment-success-toast')
      if (targetEl) {
        targetEl.remove()
      }
      return
    }

    // 8. Video Controls Toggle: data-action="toggle-video-controls"
    const videoBtn = event.target.closest('[data-action="toggle-video-controls"]')
    if (videoBtn) {
      event.preventDefault()
      const videoCard = videoBtn.closest('.video-card')
      const controls = videoCard ? videoCard.querySelector('.video-controls') : null
      if (controls) {
        controls.classList.toggle('hidden')
      }
      return
    }

    // 9. FAQ Item Toggle: data-action="toggle-faq"
    const faqBtn = event.target.closest('[data-action="toggle-faq"]')
    if (faqBtn) {
      event.preventDefault()
      const faqItem = faqBtn.closest('.faq-item')
      if (faqItem) {
        faqItem.classList.toggle('active')
        const content = faqItem.querySelector('.faq-content')
        if (content) {
          content.classList.toggle('hidden')
        }
      }
    }
  })

  // Helper: Support Tab Search Filtering
  const handleSupportSearch = (searchInput) => {
    const val = (searchInput.value || '').toLowerCase().trim()
    let matchCount = 0

    const topics = document.querySelectorAll('.topic-card')
    const videos = document.querySelectorAll('.video-card')
    const faqs = document.querySelectorAll('.faq-item')

    if (topics.length > 0 || videos.length > 0 || faqs.length > 0) {
      topics.forEach((item) => {
        const text = (item.textContent || '').toLowerCase()
        const matches = !val || text.includes(val)
        item.style.display = matches ? 'flex' : 'none'
        if (matches) matchCount++
      })

      videos.forEach((item) => {
        const text = (item.textContent || '').toLowerCase()
        const matches = !val || text.includes(val)
        item.style.display = matches ? 'flex' : 'none'
        if (matches) matchCount++
      })

      faqs.forEach((item) => {
        const text = (item.textContent || '').toLowerCase()
        const matches = !val || text.includes(val)
        item.style.display = matches ? 'block' : 'none'
        if (matches) matchCount++
      })

      const emptyState = document.getElementById('settings-support-empty-state')
      if (emptyState) {
        if (val && matchCount === 0) {
          emptyState.classList.remove('hidden')
        } else {
          emptyState.classList.add('hidden')
        }
      }
    }
  }

  // Input event delegation (Search filter & type-to-confirm validation)
  document.addEventListener('input', (event) => {
    // 1. Remove User Email Match Validation
    if (event.target.matches('#remove-modal-email-input, [data-action="validate-remove-email"]')) {
      const emailSpan = document.getElementById('remove-modal-target-email')
      const submitBtn = document.getElementById('remove-modal-submit-btn')
      if (emailSpan && submitBtn) {
        const expected = (emailSpan.getAttribute('data-target-email') || emailSpan.textContent || '').trim().toLowerCase()
        const actual = (event.target.value || '').trim().toLowerCase()
        submitBtn.disabled = expected === '' || actual !== expected
      }
      return
    }

    // 2. Settings Support Tab Search Filtering
    if (event.target.matches('#settings-tab-search-input')) {
      handleSupportSearch(event.target)
    }
  })

  // Change event delegation (e.g. programmatically cleared search inputs)
  document.addEventListener('change', (event) => {
    if (event.target.matches('#settings-tab-search-input')) {
      handleSupportSearch(event.target)
    }
  })

  // Keydown delegation for Escape key modal dismissal
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const successModal = document.getElementById('payment-success-modal')
      if (successModal) {
        successModal.remove()
      }
      const failureModal = document.getElementById('payment-failure-modal')
      if (failureModal) {
        failureModal.remove()
      }
    }
  })

  // Turbo load & DOMContentLoaded cleanup helper
  const handlePageLoad = () => {
    // If URL has query params on billing/success, clean state without full reload
    if (document.getElementById('payment-success-modal') || document.getElementById('payment-success-toast')) {
      if (window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname)
      }
    }

    // Auto-dismiss success toast after 4s
    const toast = document.getElementById('payment-success-toast')
    if (toast) {
      setTimeout(() => {
        if (document.getElementById('payment-success-toast')) {
          toast.style.opacity = '0'
          toast.style.transition = 'opacity 0.4s ease'
          setTimeout(() => { toast.remove() }, 400)
        }
      }, 4000)
    }

    // If search input has initial value, trigger filtering
    const searchInput = document.getElementById('settings-tab-search-input')
    if (searchInput && searchInput.value) {
      searchInput.dispatchEvent(new Event('input', { bubbles: true }))
    }

    // Auto-scroll active tab pill into view on mobile devices
    const tabsContainer = document.querySelector('[data-settings-tabs]')
    const activePill = tabsContainer?.querySelector('.border-\\[\\#043f42\\]')
    if (activePill && tabsContainer) {
      const pillLeft = activePill.offsetLeft
      const pillWidth = activePill.offsetWidth
      const containerWidth = tabsContainer.offsetWidth
      tabsContainer.scrollTo({
        left: pillLeft - (containerWidth / 2) + (pillWidth / 2),
        behavior: 'smooth'
      })
    }
  }

  document.addEventListener('turbo:load', handlePageLoad)
  if (document.readyState !== 'loading') {
    handlePageLoad()
  } else {
    document.addEventListener('DOMContentLoaded', handlePageLoad)
  }
}

// Initialize once
setupSettingsEventDelegation()
